module.exports = __webpack_public_path__ + "media/fireworks.b979b05d.wav";